import axiosInstance from "../../../axios";
import config from "../../../config";
import { usePersistedStore } from "../../persisted-store";

export const createOtpReportSlice = (set, get) => ({
    otpReport: {
        loading: false,
        data: {},
    },
    getBusinessOtpReport: async () => {
        const token = usePersistedStore.getState().business.currentBusiness.token;
        set(state => ({ otpReport: { ...state.otpReport, loading: true } }));
        try {
            const resp = await axiosInstance({
                method: "get",
                baseURL: config.apiUrls(),
                url: "/v1/business/OTP-Report",
                headers: { token },
            });
            set(state => ({ otpReport: { loading: false, data: resp.data } }));
        } catch (error) {
            set(state => ({ otpReport: { ...state.otpReport, loading: false } }));
        }
    }
});
